// TODO: change it to symbol
export const elFormKey = 'elForm';
export const elFormItemKey = 'elFormItem';
export const elFormEvents = {
    addField: 'el.form.addField',
    removeField: 'el.form.removeField',
};
